// Shared provenance rule for day statistics and guided team analysis.
export function forecastTiming(record, start, statistic = false) {
  const p = statistic ? record?.pre : record;
  if (!p) return "missing";
  if (
    p.calculation_timing === "postmatch" ||
    p.calculated_before_kickoff === false ||
    /backfill|replay|reconstruct/i.test(p.kind || p.calculation_source || "")
  )
    return "retrospective";
  const time = Date.parse(p.calculated_at);
  if (!Number.isFinite(time) || !Number.isFinite(start)) return "unverified";
  if (time >= start) return "retrospective";
  return "prematch";
}
